import React from 'react';
import { PaddingWrapper, TitleTariff } from './styled';
import TariffList from '~/src/components/Intercom/tariffs/tariffs';
import { Container } from '../questions/styled';

const TariffListContainer = props => {
  const { bgColor, nonBottomPadding, nonTopPadding, textColor, tariffs, title } = props;
  return (
    <PaddingWrapper bgColor={bgColor} nonBottomPadding={nonBottomPadding} nonTopPadding={nonTopPadding}>
      <Container>
        <TitleTariff data-test='titleQuestions' textColor={textColor}>{title}</TitleTariff>
        <TariffList tariffs={tariffs}/>
      </Container>
    </PaddingWrapper>
  );
};

export default TariffListContainer;
